export const ACHIEVEMENTS_LIST = [
  {
    title: 'Masterpiece Product',
    time: 'Jul 2021',
    place: 'CS UI Software Engineering Project',
  },
  {
    title: 'Champion',
    time: 'Aug 2020',
    place: 'OCBC NISP IDEATION Innovation Competition',
  },
  {
    title: 'Official Representative of Universitas Indonesia',
    time: 'May 2020',
    place: 'Paris International MUN',
  },
  {
    title: 'Most Outstanding Delegate and Best Position Paper',
    time: 'Mar 2020',
    place: 'United Nations General Assembly, Bandung MUN',
  },
  {
    title: 'Honorable Mention and Best Position Paper',
    time: 'Jan 2020',
    place: 'Special Political and Decolonization Committee, Indonesia MUN',
  },
  {
    title: 'Best Delegate',
    time: 'Nov 2019',
    place: 'United Nations Development Programme, Veteran East Java MUN',
  },
  {
    title: 'First Runner Up',
    time: 'Oct 2019',
    place: 'BSLC x BNEC Lection Business Case Competition',
  },
  {
    title: 'Most Outstanding Delegate',
    time: 'Aug 2019',
    place: 'United Nations Environment Programme, Asia Youth International MUN',
  },
]
